<template>
  <div class="stafi-validator-process">
    <div class="title">
      Register as an OV
      <div class="title-2">
        Original Validator on StaFi
      </div>
    </div>
    <div class="ov-desc">
      OV is a block producer of StaFi chain which can receive delegated stake on chain and get incetive reward from joining consensus.
    </div>

    <div class="prerequisites">
      Prerequisites
    </div>
    <div class="process-items">

      <div class="item">
        <div class="item-desc">
          1. You have registered as a validator on StaFi Chain (SV）
        </div>
      </div>

      <div class="item">
        <div class="item-desc">
          2. You meet the current criteria for screening OV
        </div>
      </div>

      <div class="item">
        <div class="item-desc">
          3. You know the penalty and risk of being an OV 
        </div>
      </div>

      <div class="item">
        <div class="item-desc">
          4. You know the nomination rules of an OV
        </div>
      </div>

    </div>

    <div class="start-btn" @click="onboard">
      Onboard
    </div>

    <DialogBtn
      v-if="dialogVisible1"
      :dialog-data="dialogData1"
      @close="cancel"
      @sure="handleOnboard"
    />

  </div>
</template>

<script>
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Api from '../../util/SubstrateApi.js';
import DialogBtn from '../../components/dialogbtn';
import LocalStorage from '../../util/localStorage.js';
import {
  web3Enable,
  web3FromSource,
} from '@polkadot/extension-dapp';

export default {
  name: 'validatorProcess',
  components: {
    DialogBtn
  },
  data() {
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang,
      dialogVisible1: false,
      dialogData1: {},
    }
  },
  methods: {
    cancel() {
      this.dialogVisible1 = false;
    },
    onboard() {
      Api.createStafiApi().then(api => {
        let currentAccount = LocalStorage.getCurrentFisAccount();
        api.query.staking.ledger(currentAccount).then(ledgerData => {
          let ledger = ledgerData.toJSON();
          if (ledger) {
            this.dialogData1 = {
              icon: require('../../assets/money.png'),
              lTitle: 'Confirm to onboard',
              content: 'Make sure your current FIS account is your Controller account',
              type: 1,
              leftBtnText: 'Cancel',
              rightBtnText: 'Onboard'
            };
            this.dialogVisible1 = true;
          } else {
            Toast({ 
              message: 'Please register as a validator on StaFi Chain first, then import and select your controller account', 
              duration: 5000 
            });
          }
        }).catch((error) => {});
      }).catch((error) => {});
    },

    handleOnboard() {
      this.dialogVisible1 = false;

      Indicator.open('Loading...');

      web3Enable(Api.getWeb3EnalbeName());
      web3FromSource(Api.getPolkadotJsSource()).then(injector => {

        Api.createStafiApi().then(api => {

          let currentAccount = LocalStorage.getCurrentFisAccount();

          api.tx.rFis
              .onboard()
              .signAndSend(currentAccount, { signer: injector.signer }, (result) => {
            
            if (result.status.isInBlock) {
              Indicator.close();
              this.clickStake = false;

              result.events
                .filter(({ event: { section } }) => section === 'system')
                .forEach(({ event: { data, method } }) => {
                  if (method === 'ExtrinsicFailed') {
                    const [dispatchError] = data
                    if (dispatchError.isModule) {
                      try {
                        const mod = dispatchError.asModule;
                        const error = data.registry.findMetaError(new Uint8Array([mod.index.toNumber(), mod.error.toNumber()]));

                        let message = 'Something is wrong, please try again!';
                        if (error.name == 'NotController') {
                          message = 'Please use your controller account';
                        } else if (error.name == 'NoSessionKey') {
                          message = 'Please register your session key first';
                        } else if (error.name == 'ValidatorLimitReached') {
                          message = 'The maximum number of onboarded validators has been reached';
                        } else if (error.name == 'AlreadyOnboard') {
                          message = 'You are already onboard';

                          setTimeout(() => {
                            this.$emit('onboardSuccess');
                          }, 3300);
                        }
                        Toast({ 
                          message: message, 
                          duration: 3000 
                        });
                      } catch (error) {
                        Toast({ 
                          message: error.message, 
                          duration: 3000 
                        });
                      }
                    }
                  } else if (method === 'ExtrinsicSuccess') {
                    Toast({ 
                      message: 'Onboard successfully', 
                      duration: 3000 
                    });

                    setTimeout(() => {
                      this.$emit('onboardSuccess');
                    }, 3300);
                  }
                });
            } else if (result.isError) {
              Indicator.close();
              this.clickStake = false;

              Toast({ 
                message: result.toHuman(), 
                duration: 3000 
              });
            }

          }).catch((error) => {
            Indicator.close();
            this.clickStake = false;
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          });

        })
        .catch((error) => {
          Indicator.close();
          this.clickStake = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
        
      });
      
    },
  }
};
</script>

<style lang="scss">

.stafi-validator-process {

  .ov-desc {
    color: #C4C4C4;
    font-size: 16px;
    margin-top: 49px;
  }

  .prerequisites {
    font-size: 20px;
    font-weight: bold;
    margin-top: 44px;
  }

  .process-items {
    margin-top: 15px;

    .item {
      margin-bottom: 30px;

      .item-title {
        font-size: 20px;
        font-weight: bold;
      }

      .item-desc {
        font-size: 16px;
        color: #C4C4C4;
        margin-top: 11px;
      }
    }
  }

  .start-btn {
      cursor: pointer;
      margin-left: 361px;
      width: 110px;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      color: #23292F;
      font-weight: bold;
      background-color: #00F3AB;
      border-radius: 21px;
      text-align: center;
      margin-top: 41px;
    }
}
  
</style>